<div class="row">
    <div class="label-container">
        <label [for]="id">{{ label }}</label>
        <span *ngIf="popoverTitle || popoverBody" class="popover-host icon-info" popoverClass="bciti-popover" [popoverTitle]="popTitle" [ngbPopover]="popoverBody"></span>
    </div>
    <span *ngIf="charLimit" class="character-limit" [class.error]="hasMaxLengthError">
        {{ 'common.field-hints.character-limit' | translate: { current: currentCharactersAmount, max: charLimit } }}
    </span>
</div>
<p *ngIf="subtitle" class="field-subtitle">{{ subtitle }}</p>
<div class="form-input-wrap">
    <input
        *ngIf="type !== 'phone'"
        [ngClass]="{ invalid: invalidPass }"
        [id]="id"
        [type]="type"
        [placeholder]="placeholder || label"
        [value]="value"
        [disabled]="disabled"
        [class.validation]="validation"
        [class.pristine]="pristine"
        [class.dirty]="dirty"
        [class.touched]="touched"
        [class.invalid]="invalid"
        [class.valid]="valid"
        (input)="onInput($event)"
        (keydown)="onKeyDown($event)"
        (blur)="onTouched()"
    />

    <input
        *ngIf="type === 'phone'"
        [id]="id"
        [type]="type"
        [placeholder]="placeholder || label"
        [value]="value"
        [disabled]="disabled"
        [class.validation]="validation"
        [class.pristine]="pristine"
        [class.dirty]="dirty"
        [class.touched]="touched"
        [class.invalid]="invalid"
        [class.valid]="valid"
        (input)="valueChange($event.target.value)"
        (blur)="onTouched()"
        maxlength="14"
    />
</div>

<div *ngIf="hint" class="hint">
    {{ hint }}
</div>

<div *ngIf="!messages" class="messages">
    <ng-content selector="app-form-error"></ng-content>
    <ng-content selector="app-form-success"></ng-content>
</div>

<ng-template #popTitle> {{ popoverTitle }} <span class="icon-info"></span> </ng-template>
